<template>
    <div>
        <div class="text-center" v-if="loader">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else>
            <v-stepper v-model="stepper" alt-labels class="borderless shadowless py-0 mt-4">
                <v-stepper-header class="borderless shadowless">

                    <v-stepper-step :complete="stepper > 1" step="1" class="text-xs-center">Consentement de
                        collecte</v-stepper-step>

                    <v-divider></v-divider>
                    <v-stepper-step :complete="stepper > 2" step="2" class="text-xs-center">Informations
                        d'identification</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="stepper > 3" step="3" class="text-xs-center">Informations
                        professionnelles</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="stepper > 4" step="4" class="text-xs-center">Informations de
                        localisation</v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step step="5" class="text-xs-center">Informations de contact</v-stepper-step>

                </v-stepper-header>

                <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">
                    {{ snackbar_message }}
                </v-snackbar>

                <v-stepper-items class="mt-4">
                    <v-form>
                        <v-stepper-content step="1">
                            eddd
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <v-card flat>
                                <v-card-title>
                                    <h5 class="primary--text">Informations d'identification</h5>
                                </v-card-title>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-layout row wrap>
                                            <v-flex xs12 sm4 align-center layout>
                                                <v-avatar size="256px" v-ripple
                                                    v-if="actor.photo_url != null && actor.photo_url.length != 0"
                                                    class="mb-3">
                                                    <img :src="`/${actor.photo_url}`" alt="avatar">
                                                </v-avatar>
                                                <image-input v-model="avatar" v-else>
                                                    <div slot="activator">
                                                        <v-avatar size="256px" v-ripple
                                                            v-if="!avatar && (actor.photo_url === null || actor.photo_url.length === 0)"
                                                            class="grey lighten-3 mb-3">
                                                            <span>Click to add avatar</span>
                                                        </v-avatar>
                                                        <v-avatar size="256px" v-ripple v-else class="mb-3">
                                                            <img :src="avatar.imageURL" alt="avatar">
                                                        </v-avatar>
                                                    </div>
                                                </image-input>
                                                <v-slide-x-transition>
                                                    <div v-if="avatar && saved == false">
                                                        <v-btn class="primary ml-2" @click="uploadImage"
                                                            :loading="saving">Save Avatar</v-btn>
                                                    </div>
                                                </v-slide-x-transition>
                                            </v-flex>

                                            <v-flex xs12 sm8>
                                                <v-container fluid>
                                                    <v-layout row wrap align-center>
                                                        <v-flex xs6 sm3>
                                                            <v-subheader>Nom</v-subheader>
                                                        </v-flex>
                                                        <v-flex xs6 sm7>
                                                            <v-text-field v-model="actor.last_name" label="Nom" value=""
                                                                solo v-validate="'required'"
                                                                :error-messages="errors.collect('nom acteur')"
                                                                data-vv-name="nom acteur" required></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs6 sm3>
                                                            <v-subheader>Prenom</v-subheader>
                                                        </v-flex>
                                                        <v-flex xs6 sm7>
                                                            <v-text-field v-model="actor.first_name" label="Prenom"
                                                                value="" v-validate="'required'"
                                                                :error-messages="errors.collect('prenom acteur')"
                                                                data-vv-name="prenom acteur" required
                                                                solo></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs6 sm3>
                                                            <v-subheader>Surnom <v-tooltip top class="md:ml-4">
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <svg v-bind="attrs" v-on="on"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="25" height="25"
                                                                            viewBox="0 0 256 256">
                                                                            <path fill="currentColor"
                                                                                d="M142 176a6 6 0 0 1-6 6a14 14 0 0 1-14-14v-40a2 2 0 0 0-2-2a6 6 0 0 1 0-12a14 14 0 0 1 14 14v40a2 2 0 0 0 2 2a6 6 0 0 1 6 6Zm-18-82a10 10 0 1 0-10-10a10 10 0 0 0 10 10Zm106 34A102 102 0 1 1 128 26a102.12 102.12 0 0 1 102 102Zm-12 0a90 90 0 1 0-90 90a90.1 90.1 0 0 0 90-90Z" />
                                                                        </svg></template>
                                                                    <span>Son nom populaire avec lequel on le
                                                                        connaît</span>
                                                                </v-tooltip></v-subheader>
                                                        </v-flex>
                                                        <v-flex xs6 sm7>
                                                            <v-text-field v-model="actor.nickname" label="Surnom"
                                                                value="" v-validate="'required'" persistent-hint
                                                                :error-messages="errors.collect('nickname')"
                                                                data-vv-name="nickname" solo></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs6 sm3>
                                                            <v-subheader>Sexe</v-subheader>
                                                        </v-flex>
                                                        <v-flex xs6 sm7>
                                                            <v-select v-model="actor.gender" :items="genders"
                                                                label="Sexe" solo v-validate="'required'"
                                                                :error-messages="errors.collect('sexe')"
                                                                data-vv-name="sexe" required></v-select>
                                                        </v-flex>
                                                        <v-flex xs6 sm3>
                                                            <v-subheader>Age</v-subheader>
                                                        </v-flex>
                                                        <v-flex xs6 sm7>
                                                            <v-text-field v-model="actor.age" type="number" label="Age"
                                                                solo
                                                                v-validate="'required|numeric|min_value:18|max_value:99'"
                                                                :error-messages="errors.collect('age')"
                                                                data-vv-name="age" required></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs6 sm3>
                                                            <v-subheader>Langue</v-subheader>
                                                        </v-flex>
                                                        <v-flex xs6 sm7>
                                                            <v-select v-model="actor.language" label="Langue"
                                                                :items="languages" item-text="name" item-value="name"
                                                                item-key="id" solo v-validate="'required'"
                                                                :error-messages="errors.collect('langue')"
                                                                data-vv-name="langue" required></v-select>
                                                        </v-flex>
                                                        <v-flex xs6 sm3>
                                                            <v-subheader>Niveau d'instruction</v-subheader>
                                                        </v-flex>
                                                        <v-flex xs6 sm7>
                                                            <v-select v-model="actor.instruction_level"
                                                                :items="school_levels" item-text="name"
                                                                item-value="name" item-key="id"
                                                                label="Niveau d'instruction" solo
                                                                v-validate="'required'"
                                                                :error-messages="errors.collect('niveau')"
                                                                data-vv-name="niveau" required></v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="info" rounded @click.native="cancel()">{{ cancel_message }}</v-btn>
                                    <v-btn color="primary" rounded @click.native="nextStep(2)"
                                        v-if="$can('create actors')">Suivant</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                            <v-card class="mb-2" flat>
                                <v-card-title>
                                    <h5 class="primary--text">Informations professionnelles</h5>
                                </v-card-title>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-layout row wrap align-center>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Type d'acteur</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.type" :items="actor_types" item-text="name"
                                                item-value="name" item-key="id" label="Choisir le type" solo
                                                @change="loadMaillons()" v-validate="'required'"
                                                :error-messages="errors.collect('type')" data-vv-name="type"
                                                required></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Chaine de valeur</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.value_chain_id" :items="chains"
                                                    item-text="name" item-value="id" item-key="id"
                                                    label="Choisir la chaine de valeur" solo v-validate="'required'"
                                                    :error-messages="errors.collect('chaine')" data-vv-name="chaine"
                                                    required>
                                                </v-select>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Maillon Principale</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.maillon_id" :items="filteredMaillons"
                                                    item-text="name" item-value="id" item-key="id"
                                                    label="Choisir le  maillon" solo v-validate="'required'"
                                                    :error-messages="errors.collect('maillon')" data-vv-name="maillon"
                                                    required>
                                                </v-select>
                                            </v-flex>


                                            <v-flex xs6 sm4>
                                                <v-subheader>Maillons Secondaires</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.maillons" :items="filteredMaillons"
                                                    item-text="name" item-value="id"
                                                    label="Choisir le maillon secondaire" solo chips
                                                    deletable-chips></v-select>
                                            </v-flex>



                                            <!-- <v-flex xs6 sm4>
                                                <v-subheader>Services Demandés</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.services" :items="services" item-text="name"
                                                    item-value="id" label="Choisir le(s) services" solo multiple chips
                                                    deletable-chips data-vv-name="service" required></v-select>
                                            </v-flex> -->
                                            <!-- <v-flex xs6 sm4>
                                                <v-subheader>Êtes-vous membre d'une organisation?</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-radio-group v-model="select" inline>
                                                    <v-radio label="Non" value="Non" color="primary"></v-radio>
                                                    <v-radio label="Oui" value="Oui" color="primary"></v-radio>
                                                </v-radio-group>
                                            </v-flex> -->
                                            <v-layout v-if="actor.type == 'Acteur Direct'">
                                                <v-flex xs6 sm4>
                                                    <v-subheader>Organisation</v-subheader>
                                                </v-flex>
                                                <v-flex xs6 sm8>

                                                    <v-autocomplete v-model="actor.organization_id"
                                                        :items="organisations" item-text="name" item-value="id"
                                                        item-key="id" label="Choisir l'organisation" solo clearable
                                                        v-validate="'required'"
                                                        :error-messages="errors.collect('organisation')"
                                                        data-vv-name="organisation" required>
                                                        <template v-slot:item="data">
                                                            <template v-if="typeof data.item !== 'object'">
                                                                <v-list-tile-content
                                                                    v-text="data.item"></v-list-tile-content>
                                                            </template>
                                                            <template v-else>
                                                                <v-list-item-content>
                                                                    <v-list-item-title
                                                                        v-html="data.item.name"></v-list-item-title>
                                                                    <v-list-item-subtitle v-if="data.item.town"
                                                                        v-html="data.item.town.name">
                                                                    </v-list-item-subtitle>
                                                                </v-list-item-content>
                                                            </template>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="info" rounded @click.native="quit()">Quitter</v-btn>

                                    <v-btn color="info" rounded @click.native="cancel()">{{ cancel_message }}</v-btn>
                                    <v-btn color="primary" rounded @click.native="stepper = 2">Précédent</v-btn>
                                    <v-btn color="primary" rounded @click.native="nextStep(3)">Suivant</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="4">
                            <v-card class="mb-2" flat>
                                <v-card-title>
                                    <h5 class="primary--text">Informations de localisation</h5>
                                </v-card-title>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-layout row wrap align-center>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Pays</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.country_id" :items="countries" item-text="name"
                                                    item-value="id" item-key="id" label="Choisir le pays" solo
                                                    v-validate="'required'" :error-messages="errors.collect('pays')"
                                                    data-vv-name="pays" required></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Departement</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.department_id" :items="departments"
                                                    item-text="name" item-value="id" item-key="id"
                                                    label="Choisir le departement" solo @change="loadMunicipalities()"
                                                    v-validate="'required'"
                                                    :error-messages="errors.collect('departement')"
                                                    data-vv-name="departement" required></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Commune</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.municipality_id"
                                                    :items="filteredMunicipalities" item-text="name" item-value="id"
                                                    item-key="id" label="Choisir la commune" solo
                                                    @change="loadDistricts()" v-validate="'required'"
                                                    :error-messages="errors.collect('commune')" data-vv-name="commune"
                                                    required></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Arrondissement</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.district_id" :items="filteredDistricts"
                                                    item-text="name" item-value="id" item-key="id"
                                                    label="Choisir l'arrondissement" solo @change="loadTowns()"
                                                    v-validate="'required'"
                                                    :error-messages="errors.collect('arrondissement')"
                                                    data-vv-name="arrondissement" required></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Village</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-select v-model="actor.town_id" :items="filteredTowns"
                                                    item-text="name" item-value="id" item-key="id"
                                                    label="Choisir la ville/village" solo v-validate="'required'"
                                                    :error-messages="errors.collect('village')" data-vv-name="village"
                                                    required></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Adresse Physique</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-textarea v-model="actor.address" label="Entrer votre adresse"
                                                    maxlength="80" rows="2" full-width solo></v-textarea>
                                            </v-flex>
                                            <!-- <v-flex xs6 sm4>
                                                <v-subheader>Longitude</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-text-field v-model="actor.longitude" label="Longitude"
                                                    solo></v-text-field>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Latitude</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-text-field v-model="actor.latitude" label="Latitude" solo></v-text-field>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Altitude</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-text-field v-model="actor.altitude" label="Altitude" solo></v-text-field>
                                            </v-flex>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Précision</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-text-field v-model="actor.precision" label="Précision"
                                                    solo></v-text-field>
                                            </v-flex> -->
                                            <!-- <v-flex xs12 sm12>
                                                <div class="map-container">
                                                    <div id="map" class="map" ref="mapElement"></div>
                                                </div>
                                            </v-flex> -->
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="info" rounded @click.native="quit()">Quitter</v-btn>
                                    <v-btn color="info" rounded @click.native="cancel()">{{ cancel_message }}</v-btn>
                                    <v-btn color="primary" rounded @click.native="stepper = 3">Précédent</v-btn>
                                    <v-btn color="primary" rounded @click.native="nextStep(4)">Suivant</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="5">
                            <v-card class="mb-2" flat>
                                <v-card-title>
                                    <h5 class="primary--text">Informations de contact</h5>
                                </v-card-title>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-layout row wrap align-center>
                                            <v-flex xs6 sm4>
                                                <v-subheader>Contacts</v-subheader>
                                            </v-flex>
                                            <v-flex xs6 sm8>
                                                <v-combobox multiple v-model="actor.contact" label="Contact" solo chips
                                                    deletable-chips class="tag-input" :search-input.sync="search"
                                                    @keyup.tab="updateContacts" @paste="updateContacts"
                                                    v-validate="'required|numeric|min:8|max:8'"
                                                    :error-messages="errors.collect('contact')" data-vv-name="contact"
                                                    required>
                                                </v-combobox>
                                            </v-flex>
                                            <!-- <v-flex xs12 sm8 offset-sm-4>
                                                <v-checkbox v-model="checkbox"
                                                    label="L'acteur dispose-t-il d'un contact Whatsapp?" required
                                                    color="primary"></v-checkbox>
                                            </v-flex> -->
                                            <v-layout>
                                                <v-flex xs6 sm4>
                                                    <v-subheader>Contact du référent (personne à contacter en cas
                                                        d’urgence)</v-subheader>
                                                </v-flex>
                                                <v-flex xs6 sm8>
                                                    <v-text-field v-model="actor.contact_whatsapp"
                                                        v-validate="'required|numeric|min:8|max:8'"
                                                        label="Contact du référent" solo required></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="info" rounded @click.native="quit()">Quitter</v-btn>
                                    <v-btn color="info" rounded @click.native="cancel()">{{ cancel_message }}</v-btn>
                                    <v-btn color="primary" rounded @click.native="stepper = 3">Précédent</v-btn>
                                    <v-btn :loading="loading" :disabled="loading" @click="save()" color="primary"
                                        rounded>Enregistrer </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-stepper-content>
                    </v-form>
                </v-stepper-items>
            </v-stepper>
        </div>
        <v-row justify="center">
            <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card class="mx-auto overflow-hidden" height="150" max-width="500">
                    <v-bottom-navigation absolute color="primary" hide-on-scroll horizontal
                        scroll-target="#scroll-threshold-example" scroll-threshold="500">
                        <v-toolbar color="primary" dark>
                            <v-toolbar-title>Lu et approuvé : </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-title @click="accept(false)">NON</v-toolbar-title>
                            <v-toolbar-title @click="accept(true)" class="ml-4">OUI</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </v-bottom-navigation>
                    <v-sheet id="scroll-threshold-example" class="overflow-y-auto pb-16" max-height="600">
                        <v-responsive height="3500">
                            <div id="scroll-threshold-example" class="pt-4" style="overflow-y: scroll !important;">
                                <h3 style="text-align: center;">
                                    RECEPISSE DE CONSENTEMENT POUR LE TRAITEMENT DE DONNEES PERSONNELLES
                                </h3>
                                <table style="margin-bottom: 50px">
                                    <tr>
                                        <th colspan="3">1. Cadre réglementaire de la collecte</th>
                                    </tr>
                                    <tr>
                                        <td colspan="3">La plateforme de gestion des acteurs (PGA) a été développée pour
                                            servir d’instrument
                                            de planification et de suivi de la mise en œuvre des activités du programme
                                            ACMA. Elle doit être
                                            utilisée d’une part pour la planification opérationnelle des activités du
                                            programme et d’autres
                                            parts pour le suivi-opérationnel des actions menées Elle permettra de
                                            générer
                                            des statistiques et
                                            des informations sur les différents évènements qui ont été conduits à date,
                                            et
                                            ainsi d’informer en
                                            temps réel la gestion du programme.</td>
                                    </tr>
                                    <tr>
                                        <th colspan="3">2. Données collectées</th>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Les données collectées sont :
                                            <ul>
                                                <li>Informations d'identification (Nom, Prénom, Surnom, Sexe, Tranche
                                                    d’âge,
                                                    Langue et photo
                                                    d'identité)</li>
                                                <li>Informations professionnelles (Chaine de valeur, Type d'acteur,
                                                    Maillon,
                                                    Services Demandés,
                                                    Organisation d'appartenance)</li>
                                                <li>Informations de localisation (Pays, Département, Commune,
                                                    Arrondissement, Village, Adresse
                                                    Physique, Longitude, Latitude, Altitude et Précision)</li>
                                                <li>Informations de contact (Contacts téléphonique, Contact Whatsapp)
                                                </li>
                                            </ul>
                                            <p>Ces données sont collectées et sont utilisées avec votre consentement et
                                                conformément à la loi n°
                                                2017-20 du 20 avril 2018 portant code du numérique en République du
                                                Bénin
                                                telle que modifiée par
                                                la loi 2020-35 du 06 janvier 2021.</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th colspan="3">3. Finalités et utilisation</th>
                                    </tr>
                                    <tr>
                                        <td colspan="3">La finalité de la collecte est :
                                            <ul class="ul-check">
                                                <li>Disposer d’une base de données sécurisée des acteurs bénéficiaires
                                                    du
                                                    programme ACMA3 ;</li>
                                                <li>Faciliter la planification des activités par l’équipe technique du
                                                    programme et ses
                                                    bénéficiaires ;</li>
                                                <li>Avoir une meilleur inclusion des acteurs économiques des filières
                                                    promues dans les zones
                                                    d’intervention du programme en s’appuyant sur une base de données
                                                    des
                                                    acteurs ;</li>
                                                <li>Recueillir la participation des acteurs économiques aux activités
                                                    planifiées par le
                                                    programme ACMA3 et ses partenaires ;</li>
                                                <li>Faciliter l’échange de données entre la plateforme de gestion des
                                                    acteurs et d’autres
                                                    systèmes opérant à travers le CVAD ;</li>
                                                <li>Etablir des carte des acteurs avec QR Code ;</li>
                                                <p></p>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th colspan="3">4. Communication des données </th>
                                    </tr>
                                    <tr>
                                        <td colspan="3"><span style="font-weight: bold">Vos données sont communiquées à
                                                :
                                            </span>
                                            <ul>
                                                <li>La société TIC AGRO BUSINESS CENTER ; spécialisée dans le
                                                    développement
                                                    d’application,
                                                    ayant son siège social à Natitingou au Bénin ; téléphone : +229 66
                                                    03 69
                                                    05 ; représentée
                                                    par son Directeur Général TCHAOU Donald ;</li>

                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3"><span style="font-weight: bold">Moyen de communication des
                                                données : </span>
                                            <p>
                                                Les données sont communiquées grâce à un système électronique d’échange
                                                d’informations sécurisé
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <span style="font-weight: bold">Finalité de la communication des données
                                                :</span>
                                            <ul>
                                                <li>Ajout et Actualisation d'information d'identité et professionnelle
                                                    des
                                                    acteurs ;</li>
                                                <li>Enregistrement de la participation des acteurs aux évènements ;</li>
                                                <li>Information et communication entre acteurs ;</li>
                                                <li>4. Centralisation des informations </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th colspan="3">5. Stockage, lieu et durée</th>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Vos données sont stockées :
                                            <ul class="ul-check">
                                                <li>sous la forme de dossier électronique ;</li>
                                                <li>au Bénin auprès de l’entreprise TIC Agrobusiness Center ;</li>
                                                <li>Pour une durée de 10 ans maximum</li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">Après la durée ci-dessus mentionnée, vos données sont supprimées
                                        </td>
                                    </tr>
                                    <tr>
                                        <th colspan="3">6. Responsable du traitement</th>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <p><span style="font-weight: bold">Sous la responsabilité de</span> :
                                                Ousmane
                                                OUEDRAOGO, CoP du
                                                programme ACMA3</p>
                                            <p><span style="font-weight: bold">Contact téléphonique </span> : (+229) 21
                                                30
                                                59 90</p>
                                            <p><span style="font-weight: bold">Adresse email </span> :
                                                oouedraogo@ifdc.org
                                            </p>
                                            <p>qui prend toutes les mesures nécessaires pour assurer leur sécurité et
                                                respecter les obligations
                                                légales en matière de responsabilité.
                                                Le responsable du traitement a le devoir de s’assurer que vos données
                                                sont
                                                traitées en toute
                                                sécurité et de vous avertir si la sécurité de vos données n’est pas
                                                respectée.
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th colspan="3">7. Vos droits</th>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <ul style="list-style-type: none">
                                                <li>a) Vous avez le droit de donner ou de retirer votre consentement
                                                    pour le
                                                    traitement et la
                                                    communication de vos données. Il est possible cependant en cas de
                                                    retrait que l’on ne puisse
                                                    pas retirer toutes les informations, notamment celles qui ont été
                                                    utilisées ;</li>
                                                <li>b) Vous avez le droit d’être informé sur les fins auxquelles vos
                                                    données
                                                    seront traitées et
                                                    sur les personnes qui auront accès à vos données ;</li>
                                                <li>c) Vous avez le droit de recevoir toutes les informations vous
                                                    concernant qui sont
                                                    enregistrées sous un format portable et lisible et de demander des
                                                    corrections et
                                                    rectifications, si certaines informations ne sont pas correctes ;
                                                </li>
                                                <li>d) Vous avez le droit de vous opposer à tout moment pour des motifs
                                                    légitimes, à ce que les
                                                    données à caractère personnel vous concernant fassent l’objet d’un
                                                    traitement ;</li>
                                                <li>e) Vous avez le droit d’exiger que soient selon les cas et dans les
                                                    meilleurs délais
                                                    rectifiées, complétées, mise à jour, verrouillées, ou supprimées les
                                                    données à caractère
                                                    personnel vous concernant, qui sont inexactes, incomplètes,
                                                    équivoques,
                                                    périmées, non
                                                    pertinentes ou dont la collecte et l’utilisation, la conservation ou
                                                    la
                                                    communication est
                                                    interdite ;</li>
                                                <li>f) Vous avez le droit de demander l’effacement d’une information
                                                    mise en
                                                    ligne vous
                                                    concernant
                                                    ;</li>
                                                <li>g) Vous avez le droit d’interroger nos services chargés de la mise
                                                    en
                                                    œuvre des traitements
                                                    automatisés dont la liste est affichée, en vue de savoir si ces
                                                    traitements portent sur des
                                                    informations nominatives vous concernant et d’en obtenir
                                                    communication.
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <table style="margin-left:0px">
                                                <tr>
                                                    <td rowspan="2" style="text-align: center;font-weight:bold">Droits
                                                        des
                                                        personnes
                                                        concernées</td>
                                                    <td colspan="5" style="text-align: center; font-weight:bold">
                                                        Modalités
                                                        d’exercice des
                                                        droits </td>
                                                </tr>
                                                <tr>
                                                    <td style="text-align: center">Disponibilité</td>
                                                    <td style="text-align: center">Mode et forme </td>
                                                    <td style="text-align: center">Service</td>
                                                    <td style="text-align: center">Délai de réponse</td>
                                                    <td style="text-align: center">Recours</td>
                                                </tr>
                                                <tr>
                                                    <td style="text-align: center">INFORMATION PREALABLE</td>
                                                    <td style="text-align: center">Oui</td>
                                                    <td style="text-align: center">Mentions légales Affichage</td>
                                                    <td style="text-align: center">DPO/IFDC</td>
                                                    <td style="text-align: center">30 jours</td>
                                                    <td style="font-weight:bold">DPO <br> APDP</td>
                                                </tr>
                                                <tr>
                                                    <td style="text-align: center">RESCTIFICATION ET SUPPRESSION</td>
                                                    <td style="text-align: center">Oui</td>
                                                    <td style="text-align: center">Requête écrite Formulaire</td>
                                                    <td style="text-align: center">DPO/IFDC</td>
                                                    <td style="text-align: center">0-30 jours</td>
                                                    <td style="font-weight:bold">DPO <br> APDP</td>
                                                </tr>
                                                <tr>
                                                    <td style="text-align: center">ACCES</td>
                                                    <td style="text-align: center">Oui</td>
                                                    <td style="text-align: center">Mentions légales Courrier
                                                        électronique et
                                                        postal</td>
                                                    <td style="text-align: center">DPO/IFDC</td>
                                                    <td style="text-align: center">0-30 jours</td>
                                                    <td style="font-weight:bold">DPO <br> APDP</td>
                                                </tr>
                                                <tr>
                                                    <td style="text-align: center">OPPOSITION</td>
                                                    <td style="text-align: center">Oui</td>
                                                    <td style="text-align: center">Requête écrite, Formulaire, Mail,
                                                        Bouton
                                                        de suppression de
                                                        compte</td>
                                                    <td style="text-align: center">DPO/IFDC</td>
                                                    <td style="text-align: center">0-30 jours</td>
                                                    <td style="font-weight:bold">DPO <br> APDP</td>
                                                </tr>

                                                <tr>
                                                    <td style="text-align: center">INTERROGATION</td>
                                                    <td style="text-align: center">Oui</td>
                                                    <td style="text-align: center">Requête écrite</td>
                                                    <td style="text-align: center">DPO/IFDC</td>
                                                    <td style="text-align: center">30 jours</td>
                                                    <td style="font-weight:bold">DPO <br> APDP</td>
                                                </tr>
                                                <tr>
                                                    <td style="text-align: center">PORTABILITE</td>
                                                    <td style="text-align: center">Oui</td>
                                                    <td style="text-align: center">Requête écrite</td>
                                                    <td style="text-align: center">DPO/IFDC</td>
                                                    <td style="text-align: center">30 jours</td>
                                                    <td style="font-weight:bold">DPO <br> APDP</td>
                                                </tr>
                                                <tr>
                                                    <td style="text-align: center">EFFACEMENT</td>
                                                    <td style="text-align: center">Oui</td>
                                                    <td style="text-align: center">Requête écrite</td>
                                                    <td style="text-align: center">DPO/IFDC</td>
                                                    <td style="text-align: center">30 jours</td>
                                                    <td style="font-weight:bold">DPO <br> APDP</td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th colspan="3">8. Plaintes</th>
                                    </tr>

                                    <tr>
                                        <td colspan="3">Si vous vous inquiétez quant à la manière dont vos
                                            données sont traitées, vous pouvez contacter votre avocat ou l'Autorité de
                                            Protection des
                                            Données à caractère Personnel (APDP) :
                                            <ul style="list-style-type: square;">
                                                <li>par téléphone au : <span style="font-weight: bold">+229 69 55 00
                                                        00</span></li>
                                                <li>par mail à l’adresse : <a style="font-weight: bold"
                                                        href="mailto:contact@apdp.bj">contact@apdp.bj</a></li>
                                            </ul>
                                            <p>Conformément à la réglementation en vigueur en matière de protection des
                                                données personnelles,
                                                vous disposez d’un droit d’accès aux informations vous concernant, ainsi
                                                qu’un droit de
                                                rectification, d’opposition, de limitation du traitement et de
                                                suppression
                                                que vous pouvez
                                                exercer par mail en vous adressant à : <a style="font-weight: bold"
                                                    href="mailto:ratinkpahoun@ifdc.org">ratinkpahoun@ifdc.org</a>, en
                                                précisant vos nom,
                                                prénom,
                                                adresse et en joignant une copie recto-verso de votre pièce d’identité
                                            </p>
                                        </td>
                                    </tr>
                                </table>
                                <!-- </v-responsive> -->
                            </div>
                        </v-responsive>
                    </v-sheet>
                </v-card>
            </v-dialog>
        </v-row>

        <!-- Dialog suggestion doublons -->
        <v-dialog v-model="duplicateDialog" max-width="700">
            <duplicate-suggestion
                v-if="duplicateDialog"
                :contact-matches="contactMatches"
                :name-matches="nameMatches"
                @cancel="duplicateDialog = false">
            </duplicate-suggestion>
        </v-dialog>

        <!-- Indicateur de vérification en cours -->
        <v-snackbar v-model="checkingDuplicates" :timeout="-1" bottom right color="info" style="z-index:999;">
            <v-progress-circular indeterminate size="16" width="2" color="white" class="mr-2"></v-progress-circular>
            Vérification des doublons...
        </v-snackbar>

    </div>
</template>
<script>
import ImageInput from '~/components/ImageInput.vue'
import DuplicateSuggestion from '~/components/DuplicateSuggestion.vue'
import Form from 'vform'
import { mapGetters, mapActions } from "vuex"
import axios from "axios"
// import { Map, tileLayer, marker, icon } from 'leaflet'
import L from 'leaflet'
import Permissions from '~/mixins/Permissions';

export default {
    name: 'actor-create-view',
    mixins: [Permissions],
    data: () => ({
        dialog: true,
        map: null,
        loader: false,
        stepper: 0,
        checkbox: false,
        public_actor: false,
        economic_actor: false,
        snackbar: false,
        snackbar_timeout: 5000,
        snackbar_color: "",
        actor: {
            first_name: '',
            last_name: '',
            nickname: '',
            gender: '',
            age: '',
            instruction_level: '',
            type: '',
            fonction: '',
            photo_url: null,
            organization_id: null,
            language: '',
            maillons: [],
            value_chain_id: null,
            maillon_id: null,
            country_id: null,
            department_id: null,
            municipality_id: null,
            district_id: null,
            town_id: null,
            address: '',
            // longitude: null,
            // latitude: null,
            // altitude: null,
            // precision: null,
            contact: [],
            // services: [],
            contact_whatsapp: '',
            receipt_consent_id: null,
        },
        search: '',
        ages: ['< ou =35 ans', '>35 ans'],
        avatar: null,
        genders: ['Homme', 'Femme'],
        saving: false,
        saved: false,
        loading: false,
        edit_mode: false,
        actorId: null,
        photo: null,
        snackbar_message: '',
        cancel_message: 'Annuler',
        filterCount: 0,
        errorsDictionnary: {
            stepFields: {
                step1: ['nom', 'prénom', 'énoncé', 'finalité', 'email', 'finalité communication', 'institution', 'date'],
                step2: ['nom acteur', 'prenom acteur', 'sexe', 'age', 'langue', 'niveau'],
                step3: ['type', 'maillon'],
                step4: ['pays', 'departement', 'commune', 'arrondissement', 'village'],
            }
        },
        in_benin: false,
        abroad_to: false,
        divValue: "",
        divValue1: "",
        selectedType: null,
        select: "Non",
        eventId: null,
        organisations: [],
        countries: [],
        contactMatches: [],
        nameMatches: [],
        duplicateDialog: false,
        checkingDuplicates: false,
        duplicateCheckTimer: null,
    }),
    components: {
        ImageInput: ImageInput,
        DuplicateSuggestion: DuplicateSuggestion,
    },
    created() {
        this.$checkPermission('view actors')
        this.actorId = this.$route.params.actorId
        this.eventId = this.$route.params.eventId
        if (this.actorId !== 'new') {
            this.edit_mode = true
        }
        this.fetchCurrentActor();
        // this.fetchCountries()
        this.fetchDepartments()
        this.fetchActorTypes()
        this.fetchSchoolLevels()
        this.fetchLanguages()
        this.fetchChains()
        this.fetchMaillons()
        // this.fetchServices()
        // this.fetchMunicipalities()
        // this.fetchDistricts()
        // this.fetchTowns()
        this.fetchOrganisations()
        this.getUtils()
    },
    mounted() {
        if (!this.edit_mode) {
            this.getLocation()
        }
    },
    watch: {
        avatar: {
            handler: function () {
                this.saved = false
            },
            deep: true
        },
        "consent.by_other": function () {
            this.consent.by_other_content = "";
        },
        "consent.in_benin": function (val) {
            if (val != "") {
                this.in_benin = true;
            } else {
                this.in_benin = false;
            }
        },
        "consent.abroad_to": function (val) {
            if (val != "") {
                this.abroad_to = true;
            } else {
                this.abroad_to = false;
            }
        },
        "consent.duration": function (val) {
            if (val != "") {
                this.consent.for_duration = true;
            } else {
                this.consent.for_duration = false;
            }
        },
        'actor.last_name'(val) {
            if (!this.edit_mode) this.scheduleDuplicateCheck()
        },
        'actor.first_name'(val) {
            if (!this.edit_mode) this.scheduleDuplicateCheck()
        },
        'actor.department_id'(val) {
            if (!this.edit_mode) this.scheduleDuplicateCheck()
        },
        'actor.municipality_id'(val) {
            if (!this.edit_mode) this.scheduleDuplicateCheck()
        },
        'actor.town_id'(val) {
            if (!this.edit_mode) this.scheduleDuplicateCheck()
        },
        'actor.type'(newVal, oldVal) {
            if (newVal && oldVal) {
                if (newVal != oldVal) {
                    // this.actor.maillons = []
                    this.actor.organization_id = null
                }
            } if (newVal == 'Acteur Direct') {
                this.errorsDictionnary.stepFields.step3.push('organisation')
                this.errorsDictionnary.stepFields.step3.push('chaine')
            } else {
                this.errorsDictionnary.stepFields.step3.pop()
            }
        },
    },
    computed: {
        filteredMunicipalities() { return this.$store.getters.getMunicipalities; },
        filteredDistricts() { return this.$store.getters.getDistricts; },
        filteredTowns() { return this.$store.getters.getTowns; },
        filteredMaillons: {
            // getter
            get: function () {
                if (this.actor.type == '' || this.selectedType == null) {
                    return this.$store.getters.maillons
                } else {
                    console.log('maillons',this.$store.getters.maillons.filter(maillon => maillon.actor_type_id === this.selectedType.id))
                    return this.$store.getters.maillons.filter(maillon => maillon.actor_type_id === this.selectedType.id)
                }
            },
            // setter
            set: function (newValue) {
                this.$store.commit('filterMaillons', newValue)
            }
        },
        ...mapGetters([
            // 'countries',
            'departments',
            'chains',
            // 'services',
            'languages',
            'actor_types',
            'school_levels'
        ])
    },

    methods: {
        scheduleDuplicateCheck() {
            clearTimeout(this.duplicateCheckTimer)
            this.duplicateCheckTimer = setTimeout(() => {
                this.checkDuplicates()
            }, 600)
        },

        async checkDuplicates() {
            const firstName = (this.actor.first_name || '').trim()
            const lastName  = (this.actor.last_name  || '').trim()

            if (firstName.length < 2 || lastName.length < 2) return

            this.checkingDuplicates = true
            try {
                const { data } = await axios.post('/api/actors/check-duplicates', {
                    first_name:       firstName,
                    last_name:        lastName,
                    gender:           this.actor.gender           || undefined,
                    age:              this.actor.age              || undefined,
                    organization_id:  this.actor.organization_id  || undefined,
                    maillon_id:       this.actor.maillon_id       || undefined,
                    municipality_id:  this.actor.municipality_id  || undefined,
                    district_id:      this.actor.district_id      || undefined,
                    town_id:          this.actor.town_id          || undefined,
                    department_id:    this.actor.department_id    || undefined,
                })

                if (data.has_results) {
                    this.contactMatches  = data.contact_matches
                    this.nameMatches     = data.name_matches
                    this.duplicateDialog = true
                } else {
                    this.contactMatches  = []
                    this.nameMatches     = []
                    this.duplicateDialog = false
                }
            } catch (e) {
                // Ne pas bloquer l'utilisateur en cas d'erreur réseau
            } finally {
                this.checkingDuplicates = false
            }
        },

        async getUtils() {
            const { data } = await axios.get('/api/countries')
            this.countries = data;
        },
        async fetchOrganisations() {
            const filteredDepartments = this.departments.filter(department => department.name == "COLLINES" || department.name == 'BORGOU' || department.name == 'DONGA');
            const departmentIds = filteredDepartments.map(department => department.id)
            const { data } = await axios.get('/api/organizations?include=town', { params: { 'department_ids': departmentIds } })
            this.organisations = data;
        },
        accept(value) {
            if (value == true) {
                this.dialog = false
                this.stepper = 2
            } else {
                this.$router.push({ name: "events.show", params: { Pid: this.eventId } });
            }
        },
        updateContacts() {
            this.$nextTick(() => {
                this.actor.contact.push(...this.search.split(","));
                this.$nextTick(() => {
                    this.search = "";
                });
            });
        },

        checkActorType(event) {
            if (event === 'Public') {
                this.public_actor = true
                this.economic_actor = false
            } else if (event === 'Membre d\'organisation') {
                this.economic_actor = true
                this.public_actor = false
            } else {
                this.public_actor = false
                this.economic_actor = false
            }
        },
        uploadImage() {
            this.saving = true
            setTimeout(() => this.savedAvatar(), 1000)
        },
        savedAvatar() {
            this.saving = false
            this.photo = this.avatar.imageFile
            this.saved = true
        },

        valideContacts() {
            if (this.actor.contact.length < 1 && (this.actor.contact_whatsapp == '' || this.actor.contact_whatsapp == null)) {
                return "Veuillez entrer le contact ou le contact du référent";
            }
            if (this.actor.contact.length > 0) {
                for (let i = 0; i < this.actor.contact.length; i++) {
                    if (!this.actor.contact[i]) {
                        return "Tous les contacts doivent être remplis.";
                    }

                    if (isNaN(this.actor.contact[i])) {
                        return "Les contacts doivent être numériques.";
                    }

                    if (this.actor.contact[i].length !== 8) {
                        return "Les contacts doivent comporter 8 chiffres.";
                    }
                }
            }
            if (this.actor.contact_whatsapp) {
                if (isNaN(this.actor.contact_whatsapp)) {
                    return "Le contact du référent doit être numérique.";
                }

                if (this.actor.contact_whatsapp.length < 8) {
                    return "Le contact du référent doit comporter 8 chiffres.";
                }
            }
            return true;
        },
        async save() {
            var validation = this.valideContacts()
            if (validation != true) {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message = validation;
                return;
            }
            // Save the actor.
            this.loading = true
            if (this.photo != null) {
                const config = { headers: { 'content-type': 'multipart/form-data' } }
                let formData = new FormData()
                formData.append("photo", this.photo)
                await axios.post("/api/upload-file", formData, config)
                    .then(response => {
                        this.actor.photo_url = response.data
                    });
            }

            // if (this.edit_mode) {
            //     this.actor.services = this.actor.services.map(service => {
            //         if (typeof service === 'object') {
            //             return service.id
            //         } else {
            //             return service
            //         }
            //     })
            // }
            let newActor = {
                first_name: this.actor.first_name,
                last_name: this.actor.last_name,
                nickname: this.actor.nickname,
                gender: this.actor.gender,
                age: this.actor.age,
                instruction_level: this.actor.instruction_level,
                type: this.actor.type,
                fonction: this.actor.fonction,
                photo_url: this.actor.photo_url,
                organization_id: this.actor.organization_id,
                language: this.actor.language,
                maillons: this.actor.maillons,
                value_chain_id: this.actor.value_chain_id,
                maillon_id: this.actor.maillon_id,
                country_id: this.actor.country_id,
                department_id: this.actor.department_id,
                municipality_id: this.actor.municipality_id,
                district_id: this.actor.district_id,
                town_id: this.actor.town_id,
                address: this.actor.address,
                contact: this.actor.contact.toString(),
                // services: this.actor.services,
                // longitude: this.actor.longitude,
                // latitude: this.actor.latitude,
                // altitude: this.actor.altitude,
                // precision: this.actor.precision,
                contact_whatsapp: this.actor.contact_whatsapp,
                receipt_consent_id: this.actor.receipt_consent_id,
                event_id: this.eventId,
            }

            if (this.edit_mode) {
                this.updateActor(newActor)
            } else {
                this.saveActor(newActor)
            }
        },
        async saveConsent() {
            let canStep = await this.stepCompleted(1)
            if (!canStep) {
                return
            }
            for (let index = 0; index < this.consent.data_communication.length; index++) {
                const element = this.consent.data_communication[index];
                if (element.value == '') {
                    this.snackbar = true;
                    this.snackbar_color = "error";
                    this.snackbar_message = "Veuillez remplir toute les lignes";
                    return;
                }
            }
            if (!this.consent.by_manual && !this.consent.by_electronic && !this.consent.by_other) {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message = "Merci de choisir un moyen de communication des données";
                return;
            }
            if (this.consent.by_other && this.consent.by_other_content == "") {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message = "Veuillez saisir un autre moyen de communication des données";
                return;
            }
            if (!this.consent.in_paper && !this.consent.in_electronic) {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message = "Veuillez choisir la forme de stockage";
                return;
            }
            if (!this.consent.in_benin && !this.consent.abroad_to) {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message = "Merci de choisir où vous stockez.";
                return;
            }
            if (this.consent.for_duration && this.consent.duration == "") {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message = "Veuillez saisir une durée.";
                return;
            }
            if (!this.consent.for_duration && !this.consent.for_period) {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message = "Veuillez sélectionner une durée.";
                return;
            }
            if (!this.consent.deleted && !this.consent.archived) {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message = "Veuillez sélectionner si vos données sont archivées ou supprimées.";
                return;
            }
            if (!this.consent.purposes_use) {
                this.snackbar = true;
                this.snackbar_color = "error";
                this.snackbar_message = "Le champ finalié est requis";
                return;
            }

            // // Save the consent.
            this.loading = true
            let communication = [];

            for (let index = 0; index < this.consent.data_communication.length; index++) {
                const element = this.consent.data_communication[index];
                communication.push(element.value);
            }
            this.consent.data_communication = communication;
            try {
                const response = await axios.post("/api/receipt-consents", this.consent);
                // console.log('Réponse du serveur:', response.data);
                this.actor.receipt_consent_id = response.data.id
                this.actor.first_name = response.data.first_name
                this.actor.last_name = response.data.last_name
                this.actor.email = response.data.email
                this.loading = false
                this.stepper = 2
            } catch (error) {
                console.error('Erreur lors de l\'upload:', error);
                this.loading = false
            }

        },
        async saveActor(actor) {
            try {
                const { data } = await axios.post('/api/actors', actor)

                this.loading = false
                this.snackbar_message = "Acteur ajouté avec succès!"
                if (this.eventId) {
                    const uri = '/api/events/presence'
                    await axios.post(uri, {
                        'actor_id': data.id,
                        'event_id': this.eventId,
                        'is_new': true,
                    });
                    this.$router.push({ name: "events.show", params: { Pid: this.eventId } });
                } else {
                    this.$root.$emit("action-event", this.snackbar_message);
                    // Redirect to the actors list.
                    this.$router.push({ name: 'actors.list' })
                }

            } catch (e) {
                if (e.response.status === 422) {
                    // Erreur de validation (422 Unprocessable Entity)
                    //this.$root.$emit("action-event", e.response.data.errors);
                    this.$dialog.message.error(e.response.data.errors, {
                        position: 'top-center'
                    })
                    //this.$router.push({ name: "events.show", params: { Pid: this.eventId } });
                }
                this.loading = false
            }

        },
        async updateActor(actor) {
            const { data } = await axios.put(`/api/actors/${this.actorId}`, actor)
            this.loading = false
            this.snackbar_message = "Acteur modifié avec succès!"
            this.$root.$emit("action-event", this.snackbar_message);
            // Redirect to the actors list.
            this.$router.push({ name: 'actors.list' })
        },

        loadMunicipalities() {
            this.$store.dispatch('loadMunicipalities', this.actor.department_id);
        },

        loadDistricts() {
            this.$store.dispatch('loadDistricts', this.actor.municipality_id);
        },

        loadTowns() {
            this.$store.dispatch('loadTowns', this.actor.district_id);
        },
        removeDepartment() {
            this.department_id = null
            this.reloadData()
        },
        removeMunicipality() {
            this.municipality_id = null
            this.reloadData()
        },
        removeDistrict() {
            this.district_id = null
            this.reloadData()
        },
        removeTown() {
            this.town_id = null
            this.reloadData()
        },
        loadMaillons() {
            this.selectedType = this.actor_types.find(type => type.name === this.actor.type);
        },
        async nextStep(step) {
            let canStep = await this.stepCompleted(step)
            if (canStep) {
                this.stepper = parseInt(step) + 1
            }
        },
        async stepCompleted(step) {
            let stepField = this.errorsDictionnary.stepFields['step' + step]
            let validations = []
            for (let index = 0; index < stepField.length; index++) {
                const field = stepField[index];

                validations.push(this.$validator.validate(field))
            }
            const results = Promise.all([
                ...validations
            ]);

            const areValid = (await results).every(isValid => isValid);

            return areValid;
        },
        async fetchCurrentActor() {
            if (this.edit_mode) {
                this.loader = true
                this.cancel_message = 'Enrégistrer et quitter'
                const { data } = await axios.get(`/api/actors/${this.actorId}`)
                this.actor = data
                this.actor.contact = this.actor.contact.split(",")
                this.checkActorType(this.actor.type)
                if (this.actor.contact_whatsapp) {
                    this.checkbox = true
                }
                this.loader = false
                // this.$nextTick(function () {
                //     this.getPosition()
                // });
            }
        },
        getLocation() {
            if ("geolocation" in navigator) {
                var geo_options = {
                    enableHighAccuracy: true,
                    maximumAge: 30000,
                    timeout: 27000
                };
                navigator.geolocation.getCurrentPosition(this.showPosition, this.showError, geo_options);
            } else {
                this.$dialog.message.error('Geolocation is not supported by this browser.', {
                    position: 'top-center'
                })
            }
        },
        showPosition(position) {
            this.actor.latitude = position.coords.latitude
            this.actor.longitude = position.coords.longitude
            this.actor.altitude = position.coords.altitude
            this.actor.precision = position.coords.accuracy

            // this.map = L.map(this.$refs['mapElement']).setView([this.actor.latitude, this.actor.longitude], 11);

            // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            //     attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            //     maxZoom: 18
            // }).addTo(this.map);

            // var myIcon = L.icon({
            //     iconUrl: window.config.appUrl + "/images/marker-icon.png",
            //     iconSize: [30, 50],
            //     iconAnchor: [25, 50],
            //     popupAnchor: [-3, -76],
            // });
            // var marker = L.marker([this.actor.latitude, this.actor.longitude], { icon: myIcon })
            //     .addTo(this.map)
            //     .bindPopup(
            //         `<h2> Initial Location </h2> lat:<b>${this.actor.latitude}</b>, long:<b>${this.actor.longitude}</b>`
            //     );
            // var self = this
            // this.map.on('click', function (e) {
            //     var lat = e.latlng.lat.toFixed(7);
            //     var lon = e.latlng.lng.toFixed(7);
            //     self.actor.latitude = lat
            //     self.actor.longitude = lon

            //     if (marker != undefined) {
            //         self.map.removeLayer(marker);
            //     };

            //     marker = L.marker([lat, lon], { icon: myIcon })
            //         .addTo(self.map)
            //         .bindPopup(
            //             `<h2> Current Position </h2> lat:<b>${lat}</b>, long:<b>${lon}</b>`
            //         );
            // });
        },
        getPosition() {
            if (this.actor.latitude == null || this.actor.longitude == null) {
                this.getLocation()
            } else {
                // this.map = L.map(this.$refs['mapElement']).setView([this.actor.latitude, this.actor.longitude], 11);

                // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                //     attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                //     maxZoom: 18
                // }).addTo(this.map);

                // var myIcon = L.icon({
                //     iconUrl: window.config.appUrl + "/images/marker-icon.png",
                //     iconSize: [30, 50],
                //     iconAnchor: [25, 50],
                //     popupAnchor: [-3, -76],
                // });
                // var marker = L.marker([this.actor.latitude, this.actor.longitude], { icon: myIcon })
                //     .addTo(this.map)
                //     .bindPopup(
                //         `<h2> Initial Location </h2> lat:<b>${this.actor.latitude}</b>, long:<b>${this.actor.longitude}</b>`
                //     );
                // var self = this
                // this.map.on('click', function (e) {
                //     var lat = e.latlng.lat.toFixed(7);
                //     var lon = e.latlng.lng.toFixed(7);
                //     self.actor.latitude = lat
                //     self.actor.longitude = lon

                //     if (marker != undefined) {
                //         self.map.removeLayer(marker);
                //     };

                //     marker = L.marker([lat, lon], { icon: myIcon })
                //         .addTo(self.map)
                //         .bindPopup(
                //             `<h2> Current Position </h2> lat:<b>${lat}</b>, long:<b>${lon}</b>`
                //         );
                // });
            }
        },
        showError(error) {
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    this.$dialog.message.error('User denied the request for Geolocation.', {
                        position: 'top-center'
                    })
                    break;
                case error.POSITION_UNAVAILABLE:
                    this.$dialog.message.error('Location information is unavailable.', {
                        position: 'top-center'
                    })
                    break;
                case error.TIMEOUT:
                    this.$dialog.message.error('The request to get user location timed out.', {
                        position: 'top-center'
                    })
                    break;
                case error.UNKNOWN_ERROR:
                    this.$dialog.message.error('An unknown error occurred.', {
                        position: 'top-center'
                    })
                    break;
            }
        },

        quit() {
            this.$router.push({ name: 'actors.list' })
        },

        cancel() {
            if (this.edit_mode) {
                this.save()
            } else {
                this.$router.push({ name: 'actors.list' })
            }
        },
        ...mapActions({
            // fetchCountries: 'fetchCountries',
            fetchDepartments: 'fetchDepartments',
            fetchMunicipalities: 'fetchMunicipalities',
            fetchDistricts: 'fetchDistricts',
            fetchTowns: 'fetchTowns',
            fetchActorTypes: 'fetchActorTypes',
            fetchSchoolLevels: 'fetchSchoolLevels',
            fetchLanguages: 'fetchLanguages',
            fetchMaillons: 'fetchMaillons',
            fetchChains: 'fetchChains',
            // fetchServices: 'fetchServices',
            // fetchOrganisations: 'fetchOrganisations'
        }),


    },
    beforeDestroy() {
        if (this.map) {
            this.map.remove();
        }
    }
}
</script>
<style scoped>
.v-stepper--alt-labels .v-stepper__step {
    justify-content: center;
    align-items: center;
    flex-basis: auto;
}

.theme--light.v-subheader {
    font-size: 1.3em;
    color: black;
}

.map-container {
    position: relative;
    height: 400px;
    width: 890px;
}

.map {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
}

table {
    /* border: 1px solid black; */
    margin-left: 65px;
    width: 90%;
    /* border-collapse: collapse; */
}

th,
td {
    /* border: 1px solid black; */
    padding: 10px;
}

th {
    text-align: start;
    /* background-color: #e2efd9; */
    padding-left: 20px;
}

ul {
    padding-left: 20px;
    list-style-type: decimal;
    list-style-position: outside;
    margin-left: 20px;
}

li {
    margin: 5px;
}

input {
    margin: 5px;
}


.ul-check {
    list-style-image: url('https://i.postimg.cc/yNGNXfnr/2422422-200.png');
    margin-left: 30px;
    margin-right: 20px;

}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/actors/create.vue